<div class="form-group row">
  <div class="col-12 prefilled-text-label">
    <label class="col-form-label field-label">
      {{ model.description }}
    </label>
    <div *ngIf="model.isHiddenInFormPDFExports" class="sm-text-secondary-text">
      <small i18n>(Hidden in Form PDF exports)</small>
    </div>
  </div>
  <div class="col-12 form-control-static prefilled-text-container">
    <div
      class="editor-content multi-line-text-preview prefilled-text"
      [innerHTML]="model.content | safeHtml"
      data-test="prefilled-text"
    ></div>
  </div>
</div>
